import React from "react";
import {useState,useEffect} from 'react';
import { LineChart,BarChart,Rectangle,Bar, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";
import axios from "axios";
import configData from "../config.json";


const HrDashboard=()=>{

  const [misData,setMisData]=useState([]);

    useEffect(() => {
      const getMisData = async () => {
        const response=await axios.get(configData.SERVER_URL+`/misDashboard/${localStorage.getItem('branchID')}`)
        setMisData(response.data);
      };
      getMisData();

    }, []);

    return(
        <>

        <div className="row well py-5">
        <div className="col-xl-4 col-sm-12 mb-3">
          <div className="card text-white bg-primary o-hidden h-100">
            <div className="card-title">Monthly Production (In Qty)</div>
            <div className="card-body" style={{ backgroundColor: "lavenderblush", padding: "20px", borderRadius: "10px" }}>
              <ResponsiveContainer width="100%" height={200} margin={{ top: 5, right: 30, left: 30, bottom: 5 }} >
              <LineChart data={misData} fontSize={10}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="monthName"/>
              <YAxis />
              <Tooltip />
              <Legend />
              <Line type="monotone" dataKey="mtQty" stroke="red" name="Target Qty"/>
              <Line type="monotone" dataKey="proQty" stroke="green" name="Production Qty" />
              </LineChart>
              </ResponsiveContainer>       

        {/* <ResponsiveContainer width="100%" height="100%">
        <BarChart width="100%" height={300} data={misData} margin={{top: 5,right: 30,left: 20, bottom: 5,}}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="monthName" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="mtQty" fill="#8884d8" activeBar={<Rectangle fill="pink" stroke="blue" />} />
          <Bar dataKey="proQty" fill="#82ca9d" activeBar={<Rectangle fill="gold" stroke="purple" />} />
        </BarChart>
        </ResponsiveContainer> */}

            </div>
            <div className="card-footer text-white clearfix small z-1" href="#">
              {/* <span className="float-right">(Amount in Lac)</span> */}
            </div>
             
          </div>
        </div>

        <div className="col-xl-4 col-sm-12 mb-3">
          <div className="card text-white bg-success o-hidden h-100">
          <div className="card-title">Monthly Sales (In Qty)</div>
          <div className="card-body" style={{ backgroundColor: "lavenderblush", padding: "20px", borderRadius: "10px" }}>
            <ResponsiveContainer width="100%" height={200} margin={{ top: 5, right: 10, left: 10, bottom: 5 }}>
              <LineChart data={misData} fontSize={10}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="monthName" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Line type="monotone" dataKey="mtQty" stroke="red" name="Target Qty"/>
              <Line type="monotone" dataKey="salesQty" stroke="green" name="Sales Qty" />
              </LineChart>
            </ResponsiveContainer>       
          </div>
          <div className="card-footer text-white clearfix small z-1" href="#">
              {/* <span className="float-right">(Amount in Lac)</span> */}
            </div>
          </div>
        </div>

        <div className="col-xl-4 col-sm-12 mb-3">
          <div className="card text-white bg-warning o-hidden h-100">
          <div className="card-title">Monthly Profit/Loss (Amount In Lac)</div>
          <div className="card-body" style={{ backgroundColor: "lavenderblush", padding: "20px", borderRadius: "10px" }}>
            <ResponsiveContainer width="100%" height={200} margin={{ top: 5, right: 10, left: 10, bottom: 5 }}>
              <LineChart data={misData} fontSize={10}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="monthName" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Line type="monotone" dataKey="profitLoss" stroke="green" name="Profit/Loss" />
              </LineChart>
            </ResponsiveContainer>       
          </div>
          <div className="card-footer text-white clearfix small z-1" href="#">
              {/* <span className="float-right">(Amount in Lac)</span> */}
            </div>
          </div>
        </div>

        {/* <div className="col-xl-6 col-sm-12 mb-3">
          <div className="card text-white bg-danger o-hidden h-100">
            <div className="card-body">
              <div className="card-body-icon">
                <i className="fa fa-fw fa-support"></i>
              </div>
              <div className="mr-5">Finish Stock</div>
            </div>
            <a className="card-footer text-white clearfix small z-1" href="#">
              <span className="float-left">View Details</span>
              <span className="float-right">
                <i className="fa fa-angle-right"></i>
              </span>
            </a>
          </div>
        </div> */}

        <div className="col-xl-4 col-sm-12 mb-3">
          <div className="card text-white bg-danger o-hidden h-100">
            <div className="card-title">Monthly Con. National Exchequer (Amount In Lac)</div>
          <div className="card-body" style={{ backgroundColor: "lavenderblush", padding: "20px", borderRadius: "10px" }}>
            <ResponsiveContainer width="100%" height={200} margin={{ top: 5, right: 10, left: 10, bottom: 5 }}>
              <LineChart data={misData} fontSize={10}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="monthName" />
              <YAxis />
              <Tooltip />
              <Legend />
              {/* <Line type="monotone" dataKey="mTargetValue" stroke="red" /> */}
              <Line type="monotone" dataKey="nationalExc" stroke="green" name="Con. National Exc." />
              {/* <Line type="monotone" dataKey="preNationalExc" stroke="blue" /> */}
              </LineChart>
            </ResponsiveContainer>       
          </div>
            <div className="card-footer text-white clearfix small z-1" href="#">
              {/* <span className="float-right">(Amount in Lac)</span> */}
            </div>
              
          </div>
        </div>

      </div>

        </>
    )
}

export default HrDashboard;